module.exports = __webpack_public_path__ + "img/splashScreen3_low.4c79dc83.jpg";